import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { ADMIN_URL } from 'src/constants/global'

interface UserAclResponse {
  ok: boolean
  acl: string[]
}

export const useUserAcl = (): string[] => {
  const { acl } = useFetch<UserAclResponse>(ADMIN_URL + '/users/acl')
  return acl
}
